import { render, staticRenderFns } from "./Baiviet.vue?vue&type=template&id=38d57ecb&scoped=true&"
import script from "./Baiviet.vue?vue&type=script&lang=js&"
export * from "./Baiviet.vue?vue&type=script&lang=js&"
import style0 from "./Baiviet.vue?vue&type=style&index=0&id=38d57ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d57ecb",
  null
  
)

export default component.exports